import request from '@/util/request';

export const uploadExcel = (formData) => {
  return request({
    url: '/api/baseImport/uploadExcel',
    method: 'post',
    headers: { 'Content-Type': 'multipart/form-data' },
    data: formData,
  });
};
